<template>
  <div class="page-info-container">
    <h1>KWMR</h1>
    <p>Browse our shows and archives!</p>
    <p>KWMR is a vital resource for building and sustaining community, standing ready to serve in times of emergency, airing locally relevant information and entertainment to listeners, creating a forum through which every voice can be heard. Our station offers instruction and experience in radio production and broadcasting skills to members of all ages.</p>
  </div>
</template>

<script type="text/javascript">
export default {
  data () { 
    return { 
      html: '', 
      title: '',
    } 
  },
  created () {

  },
  methods: { 
  
  }
}
</script>